import script from "./FilterSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterSearch.vue?vue&type=script&setup=true&lang=js"

import "./FilterSearch.vue?vue&type=style&index=0&id=0a9b11a4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a9b11a4"]])

export default __exports__